import {
  getCustomReports,
  getCustomReport,
  createCustomReport,
  updateCustomReport,
  deleteCustomReport,
  createRecurring,
  deleteRecurring,
  updateRecurring,
} from 'lib/api';
import {
  CUSTOM_REPORTS_ACTIONS,
  CreateParams,
  GetCustomReportParams,
  UpdateCustomReportParams,
  UpdateRecurringParams,
  GetCustomReportsParams /*** SUS-781 changes ***/,
} from '.';

const {
  GET_CUSTOM_REPORTS_START,
  GET_CUSTOM_REPORTS_ERROR,
  GET_CUSTOM_REPORTS_SUCCESS,
  GET_CUSTOM_REPORT_START,
  GET_CUSTOM_REPORT_ERROR,
  GET_CUSTOM_REPORT_SUCCESS,
  ADD_CUSTOM_REPORTS_START,
  ADD_CUSTOM_REPORTS_ERROR,
  ADD_CUSTOM_REPORTS_SUCCESS,
  EDIT_CUSTOM_REPORTS_START,
  EDIT_CUSTOM_REPORTS_ERROR,
  EDIT_CUSTOM_REPORTS_SUCCESS,
  DELETE_CUSTOM_REPORTS_START,
  DELETE_CUSTOM_REPORTS_ERROR,
  DELETE_CUSTOM_REPORTS_SUCCESS,
  ADD_RECURRING_START,
  ADD_RECURRING_ERROR,
  ADD_RECURRING_SUCCESS,
  EDIT_RECURRING_START,
  EDIT_RECURRING_ERROR,
  EDIT_RECURRING_SUCCESS,
  DELETE_RECURRING_START,
  DELETE_RECURRING_ERROR,
  DELETE_RECURRING_SUCCESS,
} = CUSTOM_REPORTS_ACTIONS;

export const loadCustomReports = async ({
  start /*** SUS-781 changes ***/,
  limit /*** SUS-781 changes ***/,
  dispatch,
}: GetCustomReportsParams): Promise<void> => {
  /*** SUS-781 changes ***/
  dispatch({ type: GET_CUSTOM_REPORTS_START });

  const response = await getCustomReports(start, limit).catch(
    err => err
  ); /*** SUS-781 changes ***/
  if (response instanceof Error) {
    dispatch({
      type: GET_CUSTOM_REPORTS_ERROR,
      error: response.message,
    });
    return;
  }
  dispatch({
    type: GET_CUSTOM_REPORTS_SUCCESS,
    payload: {
      customReports: response.customReports,
      count: response.count /*** SUS-781 changes ***/,
    },
  });
};

export const loadCustomReport = async ({
  reportId,
  dispatch,
}: GetCustomReportParams): Promise<void> => {
  dispatch({ type: GET_CUSTOM_REPORT_START });

  const response = await getCustomReport(reportId).catch(err => err);
  if (response instanceof Error) {
    dispatch({
      type: GET_CUSTOM_REPORT_ERROR,
      error: response.message,
    });
    return;
  }
  dispatch({
    type: GET_CUSTOM_REPORT_SUCCESS,
    payload: {
      customReport: response,
    },
  });
};

export const addCustomReport = async ({
  data,
  dispatch,
}: CreateParams): Promise<object> => {
  dispatch({ type: ADD_CUSTOM_REPORTS_START });

  const customReport = await createCustomReport({ data }).catch(err => err);

  if (customReport instanceof Error) {
    dispatch({
      type: ADD_CUSTOM_REPORTS_ERROR,
      error: customReport.message,
    });
    return {};
  }

  dispatch({
    type: ADD_CUSTOM_REPORTS_SUCCESS,
    payload: {
      customReport,
    },
  });

  return customReport;
};

export const editCustomReport = async (
  params: UpdateCustomReportParams
): Promise<object> => {
  const { data, dispatch, reportId } = params;
  dispatch({ type: EDIT_CUSTOM_REPORTS_START });

  const customReport = await updateCustomReport({
    reportId,
    data,
  }).catch(err => err);

  if (customReport instanceof Error) {
    dispatch({
      type: EDIT_CUSTOM_REPORTS_ERROR,
      error: customReport.message,
    });
    return {};
  }

  dispatch({
    type: EDIT_CUSTOM_REPORTS_SUCCESS,
    payload: {
      reportId,
      customReport,
    },
  });
  return customReport;
};

export const removeCustomReport = async ({
  data,
  dispatch,
}: CreateParams): Promise<void> => {
  dispatch({ type: DELETE_CUSTOM_REPORTS_START });

  const response = await deleteCustomReport(data.reportId).catch(err => err);
  if (response instanceof Error) {
    dispatch({
      type: DELETE_CUSTOM_REPORTS_ERROR,
      error: response.message,
    });
    return;
  }
  const payload = {
    reportId: data.reportId,
  };
  dispatch({ type: DELETE_CUSTOM_REPORTS_SUCCESS, payload });
};

export const addRecurring = async (
  params: UpdateCustomReportParams
): Promise<any> => {
  const { data, dispatch, reportId } = params;
  dispatch({ type: ADD_RECURRING_START });

  const recurring = await createRecurring({
    reportId,
    data,
  }).catch(err => err);

  if (recurring instanceof Error) {
    dispatch({
      type: ADD_RECURRING_ERROR,
      error: recurring.message,
    });
    return;
  }

  dispatch({
    type: ADD_RECURRING_SUCCESS,
    payload: {
      reportId,
      recurring,
    },
  });
  return recurring;
};

export const editRecurring = async (
  params: UpdateRecurringParams
): Promise<any> => {
  const { data, dispatch, reportId, recurringId } = params;
  dispatch({ type: EDIT_RECURRING_START });

  const recurring = await updateRecurring({
    reportId,
    recurringId,
    data,
  }).catch(err => err);

  if (recurring instanceof Error) {
    dispatch({
      type: EDIT_RECURRING_ERROR,
      error: recurring.message,
    });
    return;
  }

  dispatch({
    type: EDIT_RECURRING_SUCCESS,
    payload: {
      reportId,
      recurring,
    },
  });
  return recurring;
};

export const removeRecurring = async ({
  data,
  dispatch,
}: CreateParams): Promise<void> => {
  dispatch({ type: DELETE_RECURRING_START });

  const response = await deleteRecurring(data.reportId, data.recurringId).catch(
    err => err
  );
  if (response instanceof Error) {
    dispatch({
      type: DELETE_RECURRING_ERROR,
      error: response.message,
    });
    return;
  }
  const payload = {
    reportId: data.reportId,
    recurringId: data.recurringId,
  };
  dispatch({ type: DELETE_RECURRING_SUCCESS, payload });
};
